import { DatePicker } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Button, Styles } from './styles';

const { RangePicker } = DatePicker;
const DATE_FORMAT = 'DD/MM/YYYY';

function FiltroPeriodo({ handleDates, dateMin, dateMax, rangeSize }) {
  const [isActiveButton, setIsActiveButton] = useState(true);
  const [datesValidation, setDatesValidation] = useState([]);
  const [datesCalendar, setDatesCalendar] = useState();
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [dates, setDates] = useState();

  const isdataUltrapassada = date => date && moment().isAfter(date);

  const getDataFinalLimite = date => {
    if (isdataUltrapassada(date)) {
      return moment(date);
    }

    return moment();
  };

  const periodoSeteDias = date => [
    moment(date).subtract(6, 'days'),
    moment(date),
  ];

  const disabledMaxMin = currentDate => {
    const tooLateMax =
      dateMax && currentDate.diff(dateMax.startOf('day'), 'days') > 0;
    const tooEarlyMin =
      dateMin && dateMin.diff(currentDate.startOf('day'), 'days') > 0;

    return tooLateMax || tooEarlyMin;
  };

  const disabledRangeSize = currentDate => {
    if (!rangeSize || !datesValidation || datesValidation.length === 0) {
      return false;
    }

    const tooLate =
      datesValidation[0] &&
      currentDate.diff(datesValidation[0], 'days') > rangeSize;
    const tooEarly =
      datesValidation[1] &&
      datesValidation[1].diff(currentDate, 'days') > rangeSize;
    return tooEarly || tooLate;
  };

  const disabledDate = currentDate =>
    disabledMaxMin(currentDate) || disabledRangeSize(currentDate);

  const handlePeridoSemana = () => {
    setDates(null);
    setIsActiveButton(true);

    const dataFim = getDataFinalLimite(dateMax);

    const [dataInicio, dataFinal] = periodoSeteDias(dataFim);

    handleDates(dataInicio, dataFinal);
  };

  const onCalendarChange = (data, dataStr, { range }) => {
    if (dates && rangeSize && range === 'end') {
      setDatesCalendar([undefined, data[1]]);
      setDatesValidation([undefined, data[1]]);
    } else {
      setDatesValidation(data);
    }
  };

  const onOpenChange = open => {
    setCalendarOpen(open);
    if (open) {
      const dataInicioDefault = dates ? [dates[0]] : [];
      setDatesCalendar(dataInicioDefault);
      setDatesValidation([]);
    } else {
      setDatesCalendar(undefined);
    }
  };

  const onChangePeriodo = data => {
    setIsActiveButton(false);
    setDates(data);
    if (!data || data.length === 0) {
      handlePeridoSemana();
    } else {
      const [dInicio, dFinal] = data;
      handleDates(dInicio.startOf('day'), dFinal.endOf('day'));
    }
  };

  useEffect(() => {
    handlePeridoSemana();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateMin, dateMax]);

  return (
    <>
      <Styles />
      <Button
        onClick={handlePeridoSemana}
        className={isActiveButton ? 'btnAtivo' : 'btnInativo'}
      >
        7 Dias
      </Button>

      <RangePicker
        aria-label="rangePickerFiltro"
        open={calendarOpen}
        allowClear={false}
        disabledDate={disabledDate}
        defaultPickerValue={[dateMin || dateMax, dateMin || dateMax]}
        value={datesCalendar || dates}
        onChange={onChangePeriodo}
        onCalendarChange={onCalendarChange}
        onOpenChange={onOpenChange}
        format={DATE_FORMAT}
      />
    </>
  );
}

FiltroPeriodo.propTypes = {
  handleDates: PropTypes.func.isRequired,
  dateMin: PropTypes.objectOf(PropTypes.any),
  dateMax: PropTypes.objectOf(PropTypes.any),
  rangeSize: PropTypes.number,
};

FiltroPeriodo.defaultProps = {
  dateMin: undefined,
  dateMax: undefined,
  rangeSize: 0,
};

export default FiltroPeriodo;
